import {
    VerificationTransactionDetailsAssertionScoreBreakdown,
    FormattedVerificationTransactionDetailsAssertionScoreBreakdown
} from "@idw-types/data/verification-transaction-details";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsAssertionScoreBreakdowns = (
    assertionScoreBreakdowns: Array<VerificationTransactionDetailsAssertionScoreBreakdown>,
): Array<FormattedVerificationTransactionDetailsAssertionScoreBreakdown> => {
    return assertionScoreBreakdowns.map(breakdown => formatVerificationTransactionDetailsAssertionScoreBreakdown(breakdown));
};

export const formatVerificationTransactionDetailsAssertionScoreBreakdown = (
    assertionScoreBreakdown: VerificationTransactionDetailsAssertionScoreBreakdown,
): FormattedVerificationTransactionDetailsAssertionScoreBreakdown => {
    let dateCreated = null;
    if (assertionScoreBreakdown.dateCreated) {
        dateCreated = new Date(parseInt(assertionScoreBreakdown.dateCreated));
    }

    return {
        apiKey: assertionScoreBreakdown.apiKey,
        asi: assertionScoreBreakdown.asi,
        assertionScore: safelyParseIntFromString(assertionScoreBreakdown.assertionScore),
        assertionScoreRangeMax: safelyParseIntFromString(assertionScoreBreakdown.assertionScoreRangeMax),
        assertionScoreRangeMin: safelyParseIntFromString(assertionScoreBreakdown.assertionScoreRangeMin),
        dateCreated: dateCreated,
        id: assertionScoreBreakdown.id,
        normalizedAssertionScore: safelyParseIntFromString(assertionScoreBreakdown.normalizedAssertionScore),
        rawAssertionScore: safelyParseIntFromString(assertionScoreBreakdown.rawAssertionScore),
        userAcquiredScoreHistoryID: assertionScoreBreakdown.userAcquiredScoreHistoryID,
        userID: assertionScoreBreakdown.userID
    };
};